import * as React from "react";

import { MenuState } from "./types";

export const initialState: MenuState = {
  showMenu: () => {},
};

export const MenuContext = React.createContext(initialState);
